<script>
	import { activeMetric, activeFeature } from "./stores.js";

	$: getDesc = () => {
		let desc;
		if ($activeFeature.properties.state_id == "USA")
			desc = $activeMetric.descriptionUSA;
		if (!desc) desc = $activeMetric.description;
		return desc;
	};
</script>

<style type="text/scss">
	@import "./style/vars";
</style>

<div class="container">
	<div class="logo">
		<img alt="CCA CC of America" src="assets/cca-logo.svg" />
	</div>
	{#if $activeMetric}
		<div class="data">
			<h2>
				<span class="metric">{$activeMetric.name}</span>
			</h2>
			<h3>{getDesc()}</h3>
		</div>
	{/if}
</div>
